
import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';

import { ImpalaLinkedService } from 'app/model/linkedservice/impala.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.impala.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.Impala_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.Impala_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: ImpalaLinkedService.MODEL // Linked service redefined
        }
    }
})
export class ImpalaObjectDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
